<z-form-field [class]="fieldClass()">
    @if (label()) {
        <label z-form-label class="notes-textarea-field__label" [attr.for]="controlId()">
            {{ label() }}
            @if (requiredAsterisk()) {
                <span class="notes-textarea-field__required" aria-hidden="true">*</span>
            }
        </label>
    }
    <z-form-control>
        <div
            class="notes-textarea-field__control-shell"
            [class.notes-textarea-field__control-shell--capped]="isHeightCapped()"
            [style.--notes-textarea-max-height.px]="textareaHeightCapPx()"
        >
            <textarea
                #textareaEl
                [id]="controlId()"
                [class]="textareaClasses()"
                [attr.rows]="rows()"
                [placeholder]="placeholder()"
                [disabled]="isDisabled()"
                [attr.maxlength]="maxLength() ?? null"
                [attr.aria-invalid]="errorMessage() ? 'true' : 'false'"
                [attr.aria-describedby]="errorMessage() ? controlId() + '-error' : null"
                (input)="onInput($event)"
                (blur)="onBlur()"
            ></textarea>
        </div>
    </z-form-control>
    @if (showFooterRow()) {
        <div class="notes-textarea-field__footer">
            @if (errorMessage()) {
                <z-form-message
                    zType="error"
                    class="notes-textarea-field__error"
                    [attr.id]="controlId() + '-error'"
                    >{{ errorMessage() }}</z-form-message
                >
            }
            @if (showCounter() && maxLength() != null && maxLength()! > 0) {
                <span
                    class="notes-textarea-field__count"
                    [class.notes-textarea-field__count--below-min]="highlightBelowMin()"
                    aria-live="polite"
                >
                    {{ charCount() }} / {{ maxLength() }}
                </span>
            }
        </div>
    }
    <ng-content select="[notesTextareaAddon]" />
</z-form-field>
